import React, { useEffect, useMemo, useParams, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { Box, Button, IconButton, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { Card } from "@mui/material";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TableMaestroDeep from "../../verticales/TableMaestrosDepp.tsx";
import fetchData from "verticales/FetchData";
import MDButton from "components/MDButton";
import UtilModal from "verticales/UtilModalDisponibilidad.js";
import AppLoading from "verticales/AppLoading.tsx";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import Tooltip from "@mui/material/Tooltip";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ResultClientes from "./componentes/resultClientes";
import CardEc2 from "./componentes/CardEc2";
import MDTypography from "components/MDTypography";
// import { ContinuousColorLegend } from "@mui/x-charts";
import { useSearchParams } from "react-router-dom";

const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.MuiMultiSectionDigitalClockSection-item": {
            fontSize: "1rem", // Change font size
            // color: "blue", // Change text color
            // backgroundColor: "lightyellow", // Change background color
          },
        },
      },
    },
  },
});

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "deep-client";

function DeepClient(props: any) {
  // declaracion de variables de la pantalla
  const [datoBusqueda, setDatoBusqueda] = useState("");
  const [dataEc2, setDataEc2] = useState([]);
  const [dataRds, setDataRds] = useState([]);
  const [selectedDate, SetselectedDate] = React.useState(dayjs(new Date()));

  const [searchParams] = useSearchParams();
  const instanceIdFromUrl = searchParams.get("instance_id");
  console.log("Instancia seleccionada Deep Client:", instanceIdFromUrl);

  // **Nuevo useEffect para manejar instanceIdFromUrl**
  useEffect(() => {
    if (instanceIdFromUrl) {
      setDatoBusqueda(instanceIdFromUrl);
      handleButtonClick(instanceIdFromUrl);
    }
  }, [instanceIdFromUrl]);

  const handleButtonClick = async (searchValue = datoBusqueda) => {
    setShowDatePicker(true);
    handleOpenModal({ datoBusqueda: searchValue });
  };

  const handleFechaClick = async () => {
    // console.log("Fecha en Time", selectedDate.toDate().getTime());
    let ajusteFecha = selectedDate.second(0).millisecond(0);
    const timeSelected = ajusteFecha.valueOf();
    const twoDaysInMilliseconds = 2 * 24 * 60 * 60 * 1000;
    const timeBack = timeSelected - twoDaysInMilliseconds;

    // console.log("Tiempo convertirdo a Milisegundos", timeSelected);
    // console.log("Tiempo atras a Milisegundos", timeBack);
  };

  /** Segmento de la ventana emergente  */
  const [rowSelect, setRowSelect] = React.useState({});
  const [openModal, setOpenModal] = React.useState(false);
  const [blockingEc2, setBlockingEc2] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleOpenModal = (row) => {
    setRowSelect(row);
    setOpenModal(true);
  };

  const handleCloseModal = async (row) => {
    if (row?.original) {
      setBlockingEc2(true);
      // console.log("row.......", row.original);
      //console.log("apsosss!!!...............", datoBusqueda);
      const params = {
        action: "get-ec2-by-ip-dbname",
        params: {
          databaseName: row.original.name_database,
          databaseIp: row.original.ip,
        },
      };
      // console.log(".......", params);
      try {
        const resp = await fetchData(url, context, params);
        // console.log("Data cliente...", resp.rows);
        setDataEc2(resp.rows);
      } catch (error) {
        console.error("Error fetching data: ", error);
        setDataEc2([]);
      } finally {
        setBlockingEc2(false);
      }
    } else {
      setDataEc2([]);
    }
    setOpenModal(false);
  };

  const renderView = () => {
    return (
      <ResultClientes
        row={rowSelect}
        data={rowSelect.original}
        handleCloseModal={handleCloseModal}
      />
    );
  };

  const cardColors = {
    "ERP.NET": "#cddc39",
    "SBS.NET": "#e3f2fd",
    Nomina: "#f3e5f5",
    Pos: "#e0f2f1",
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={1}>
        <Card>
          <Grid container sx={{ padding: "5px" }}>
            <Grid item xs={12} md={12} lg={12} sx={{ padding: "5px" }}>
              <MDBox p={2}>
                <TextField
                  id="datoBusqueda"
                  value={datoBusqueda}
                  onChange={(event) => setDatoBusqueda(event.target.value)}
                  label="Ingrese datos + 5"
                  sx={{ width: "25ch" }}
                />
                <MDButton disableElevation onClick={() => handleButtonClick()}>
                  {" "}
                  {/* Llama sin argumento */}
                  Buscar
                </MDButton>
              </MDBox>

              {showDatePicker && (
                <MDBox m={2} sx={{ width: "100%" }}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box components={["DateTimePicker", "DateTimePicker"]}>
                          <ThemeProvider theme={theme}>
                            <DateTimePicker
                              label="Tiempo de inicio"
                              defaultValue={dayjs(new Date())}
                              value={selectedDate}
                              onChange={(newValue) => SetselectedDate(newValue)}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                              sx={{
                                "& .MuiInputBase-input": {
                                  // backgroundColor: "#f5f5f5", // Fondo claro en el campo
                                  padding: "12px",
                                  fontSize: 13,
                                },
                              }}
                            />
                          </ThemeProvider>
                        </Box>
                      </LocalizationProvider>
                    </Grid>
                    <Grid item>
                      <MDButton
                        color="info"
                        variant="contained"
                        disableElevation
                        onClick={handleFechaClick}
                      >
                        Consultar Fecha
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </Grid>
            {dataEc2.map((ec2, index) => {
              const producto = ec2.resumen_instalaciones.split("--")[0];
              const cardColor = cardColors[producto] || "#ffffff";

              return (
                <Grid
                  xs={12}
                  md={6}
                  lg={4}
                  sx={{ padding: "4px" }}
                  key={ec2.instance_name || index}
                >
                  <CardEc2
                    sx={{
                      backgroundColor: cardColor,
                    }}
                    label="Capa Aplicativa"
                    title={`${ec2.instance_id} - ${producto}`}
                    description={
                      <>
                        La instancia {ec2.instance_name} tiene {ec2.numero_clientes} clientes
                        instalados en el recurso {""}
                        <Button
                          variant="text"
                          color="info"
                          onClick={() => window.open("https://siesaerp08app3.siesacloud.com/")}
                          sx={{ padding: 0, minWidth: 0, textTransform: "none" }}
                        >
                          (ver clientes)
                        </Button>{" "}
                      </>
                    }
                    action={{
                      color: "info",
                      label: "Hola",
                      labelButton: "view project",
                    }}
                    extraInfo={{
                      instanceType: ec2.instance_type,
                      producto: ec2.producto,
                      cores: ec2.default_cores,
                      vcpus: ec2.default_vcpus,
                      memory: ec2.memory_info,
                      diskInfo: ec2.disk_info
                        .split(";")
                        .map((disk) => disk.trim())
                        .join(" | "),
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Card>
      </MDBox>
      <Footer />
      <UtilModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        renderView={renderView}
      />
    </DashboardLayout>
  );
}

export default DeepClient;
